import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader2 } from "lucide-react";
import { fetchCourseEnrollments } from "../../redux/slices/courseSlice";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import { formatDate } from "../../lib/utils";

function CourseEnrollmentsPanel({ courseId }) {
  const dispatch = useDispatch();
  const { enrollments, loading } = useSelector((s) => s.course);

  useEffect(() => {
    if (courseId) dispatch(fetchCourseEnrollments(courseId));
  }, [dispatch, courseId]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Enrollments</CardTitle>
        <CardDescription>
          Learners enrolled in this course ({enrollments?.length ?? 0})
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading && !enrollments?.length ? (
          <div className="flex justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : !enrollments?.length ? (
          <p className="text-sm text-muted-foreground py-4">
            No enrollments yet.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Profile</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Score</TableHead>
                <TableHead>Streak</TableHead>
                <TableHead>Enrolled</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {enrollments.map((e) => (
                <TableRow key={e.id}>
                  <TableCell>
                    {e.profile?.profile_name ||
                      e.profile?.full_name ||
                      e.profile_id ||
                      "—"}
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">{e.status || "active"}</Badge>
                  </TableCell>
                  <TableCell>{e.total_score ?? "0"}</TableCell>
                  <TableCell>{e.streak_days ?? 0}</TableCell>
                  <TableCell>
                    {e.enrolled_at
                      ? formatDate(e.enrolled_at)
                      : "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}

export default CourseEnrollmentsPanel;
